import { useState, useEffect } from "react";
import React from "react";
import Sidenav from "../components/Sidenav";
import Toolbar from "@mui/material/Toolbar";
import { experimentalStyled as styled } from "@mui/material/styles";
import Box from "@mui/material/Box";
import { DataGrid } from "@mui/x-data-grid";
import Paper from "@mui/material/Paper";
import axios from "axios";
import Button from "@mui/material/Button";
import Typography from "@mui/material/Typography";
import Modal from "@mui/material/Modal";
import AddCircleOutlineIcon from "@mui/icons-material/AddCircleOutline";
import TextField from "@mui/material/TextField";
import { Stack } from "@mui/material";
import { TextareaAutosize as BaseTextareaAutosize } from "@mui/base/TextareaAutosize";
import MenuItem from "@mui/material/MenuItem";
import InputLabel from "@mui/material/InputLabel";
import FormControl from "@mui/material/FormControl";
import Select from "@mui/material/Select";
import CloudUploadIcon from "@mui/icons-material/CloudUpload";
import Swal from "sweetalert2";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import IconButton from "@mui/material/IconButton";
import { DemoContainer } from "@mui/x-date-pickers/internals/demo";
import { LocalizationProvider, DatePicker } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";
import { DateField } from "@mui/x-date-pickers/DateField";
import dayjs from "dayjs";
import { set } from "date-fns";
import { use } from "react";
import config from "../config/config";

const drawerWidth = 240;
const token = localStorage.getItem("token")?.replace(/['"]/g, "");

// const rows = [
//   {
//     id: 1,
//     img: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     name: "John Smith",
//     email: "fX5Hh@example.com",
//     mobile: 1234567890,
//     address: "123 Main St, Anytown, USA",
//     date: "2022-01-01",
//   },
//   {
//     id: 2,
//     img: "https://images.pexels.com/photos/415263/pexels-photo-415263.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//     name: "Jane Doe",
//     email: "jane@example.com",
//     mobile: 9876543210,
//     address: "456 Elm St, Othertown, USA",
//     date: "2022-02-01",
//   },
//   {
//     id: 3,
//     img: "https://images.pexels.com/photos/20441996/pexels-photo-20441996/free-photo-of-short-hair-man-in-t-shirt.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//     name: "Alice Johnson",
//     email: "alice@example.com",
//     mobile: 4561237890,
//     address: "789 Oak St, Sometown, USA",
//     date: "2022-03-01",
//   },
//   {
//     id: 4,
//     img: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     name: "John Smith",
//     email: "fX5Hh@example.com",
//     mobile: 1234567890,
//     address: "123 Main St, Anytown, USA",
//     date: "2022-01-01",
//   },
//   {
//     id: 5,
//     img: "https://images.pexels.com/photos/415263/pexels-photo-415263.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//     name: "Jane Doe",
//     email: "jane@example.com",
//     mobile: 9876543210,
//     address: "456 Elm St, Othertown, USA",
//     date: "2022-02-01",
//   },
//   {
//     id: 6,
//     img: "https://images.pexels.com/photos/20441996/pexels-photo-20441996/free-photo-of-short-hair-man-in-t-shirt.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//     name: "Alice Johnson",
//     email: "alice@example.com",
//     mobile: 4561237890,
//     address: "789 Oak St, Sometown, USA",
//     date: "2022-03-01",
//   },
//   {
//     id: 7,
//     img: "https://images.pexels.com/photos/220453/pexels-photo-220453.jpeg?auto=compress&cs=tinysrgb&dpr=1&w=500",
//     name: "John Smith",
//     email: "fX5Hh@example.com",
//     mobile: 1234567890,
//     address: "123 Main St, Anytown, USA",
//     date: "2022-01-01",
//   },
//   {
//     id: 8,
//     img: "https://images.pexels.com/photos/415263/pexels-photo-415263.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//     name: "Jane Doe",
//     email: "jane@example.com",
//     mobile: 9876543210,
//     address: "456 Elm St, Othertown, USA",
//     date: "2022-02-01",
//   },
//   {
//     id: 9,
//     img: "https://images.pexels.com/photos/20441996/pexels-photo-20441996/free-photo-of-short-hair-man-in-t-shirt.jpeg?auto=compress&cs=tinysrgb&w=1260&h=750&dpr=2",
//     name: "Alice Johnson",
//     email: "alice@example.com",
//     mobile: 4561237890,
//     address: "789 Oak St, Sometown, USA",
//     date: "2022-03-01",
//   },
// ];

// const VisuallyHiddenInput = styled("input")({
//   display: "none",
// });

const blue = {
  100: "#DAECFF",
  200: "#b6daff",
  400: "#3399FF",
  500: "#007FFF",
  600: "#0072E5",
  900: "#003A75",
};

const grey = {
  50: "#F3F6F9",
  100: "#E5EAF2",
  200: "#DAE2ED",
  300: "#C7D0DD",
  400: "#B0B8C4",
  500: "#9DA8B7",
  600: "#6B7A90",
  700: "#434D5B",
  800: "#303740",
  900: "#1C2025",
};

const Textarea = styled(BaseTextareaAutosize)(
  ({ theme }) => `
  box-sizing: border-box;
  width: 320px;
  font-family: 'IBM Plex Sans', sans-serif;
  font-size: 0.875rem;
  font-weight: 400;
  line-height: 1.5;
  padding: 8px 12px;
  border-radius: 8px;
  color: ${theme.palette.mode === "dark" ? grey[300] : grey[900]};
  background: ${theme.palette.mode === "dark" ? grey[900] : "#fff"};
  border: 1px solid ${theme.palette.mode === "dark" ? grey[700] : grey[200]};
  box-shadow: 0 2px 2px ${theme.palette.mode === "dark" ? grey[900] : grey[50]};

  &:hover {
    border-color: ${blue[400]};
  }

  &:focus {
    border-color: ${blue[400]};
    box-shadow: 0 0 0 3px ${theme.palette.mode === "dark" ? blue[600] : blue[200]};
  }

  /* firefox */
  &:focus-visible {
    outline: 0;
  }
`
);

const paginationModel = { page: 0, pageSize: 5 };

export default function Projects() {
  const columns = [
    {
      field: "actions",
      headerName: "Actions",
      width: 150,
      sortable: false,
      renderCell: (params) => (
        <div>
          {/* Edit Button */}
          <IconButton
            color="primary"
            onClick={() => handleEdit(params.row)}
            title="Edit"
            width={100}
          >
            <EditIcon />
          </IconButton>
          {/* Delete Button */}
          <IconButton
            color="secondary"
            onClick={() => handleDelete(params.row)}
            title="Delete"
            width={100}
          >
            <DeleteIcon />
          </IconButton>
        </div>
      ),
    },
    // {
    //   field: "img",
    //   headerName: "Image",
    //   width: 100,
    //   renderCell: (params) => (
    //     <img
    //       src={params.value}
    //       alt="Product"
    //       style={{ width: 50, height: 50 }}
    //     />
    //   ),
    //   sortable: false,
    // },
    { field: "proj_name", headerName: "Project Name", width: 150 },

    // {
    //   field: "address",
    //   headerName: "Address",
    //   description: "This column has a value getter and is not sortable.",

    //   width: 240,
    // },
    {
      field: "start_dt",
      headerName: "Project Start Date",
      description: "This column has a value getter and is not sortable.",

      width: 160,
    },
  ];
  useEffect(() => {
    fetchData(); // Call the fetchData function when the page loads
  }, []);
  const handleFileUpload = async (event) => {
    const files = event.target.files;
    if (files.length === 0) return;

    const formData = new FormData();
    formData.append("file", files[0]); // Add the first selected file to the FormData object

    try {
      const response = await axios.post(
        `${config.baseUrl}/File/products`,
        formData,
        {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        }
      );

      console.log("Upload successful", response.data);
      // Assuming the API returns a URL for the uploaded image, set it in the state
      setUploadedImage(response.data.fullUrlPath); // Update with the URL of the uploaded image
    } catch (error) {
      console.error("Error uploading file", error);
    }
  };
  const [rows, setRows] = useState([]); // State to hold API data
  const [loading, setLoading] = useState(true); // State for loading indicator
  const [open, setOpen] = React.useState(false);
  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);
  const [proj_name, setProdName] = useState("");
  const [prod_nameError, setProdNameError] = useState("");
  const [rate, setRate] = useState("");
  const [rateError, setRateError] = useState("");
  const [start_dt, setDateOfPurchase] = useState("");
  const [date_of_purchase_error, setDateOfPurchase_error] = useState("");
  const [selectedDate, setSelectedDate] = useState("YYYY-MM-DD");
  const [selectedUserId, setSelectedUserId] = useState(null);
  const [uploadedImage, setUploadedImage] = useState(null); // State to hold uploaded image URL
  const [creator_id, setCreatorId] = useState(null);
  const handleEdit = async (row) => {
    try {
      const response = await axios.get(
        `${config.baseUrl}/Projects/projectsById?id=${row.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const userData = response.data[0]; // Access the first object in the array

      if (userData) {
        // Log the fetched user data for debugging
        console.log("Fetched user data:", userData);

        // Set state
        setProdName(userData.proj_name || "");
        setDateOfPurchase(userData.start_dt || "");
        setCreatorId(localStorage.getItem("user_id"));
        // setRate(userData.rate || "");
        // setUploadedImage(userData.img || null);
        setSelectedUserId(userData.id);

        // Open modal after setting data
        handleOpen();
      } else {
        console.error("Product data not found in response");
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
    }
  };

  const handleDelete = async (row) => {
    try {
      // Fetch user details
      const response = await axios.get(
        `${config.baseUrl}/Projects/projectsById?id=${row.id}`,
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
      const userData = response.data[0]; // Access the first object in the array

      if (userData) {
        // Log the fetched user data for debugging
        console.log("Fetched product data:", userData);

        // Show confirmation alert
        const result = await Swal.fire({
          title: "Are you sure?",
          text: "You won't be able to revert this!",
          icon: "warning",
          showCancelButton: true,
          confirmButtonColor: "#3085d6",
          cancelButtonColor: "#d33",
          confirmButtonText: "Yes, delete it!",
        });

        if (result.isConfirmed) {
          try {
            // Send delete request
            const deleteResponse = await axios.post(
              `${config.baseUrl}/Projects/deleteProjects`,
              { id: row.id, modifier_id: localStorage.getItem("user_id") },
              {
                headers: {
                  Authorization: `Bearer ${token}`,
                  "Content-Type": "application/json",
                },
              }
            );

            // Handle delete response
            if (deleteResponse.status === 200) {
              console.log(
                "User successfully deleted:",
                deleteResponse.data.executeMessage
              );
              fetchData(); // Refresh the data
              Swal.fire("Deleted!", "The product has been deleted.", "success");
            } else {
              console.error(
                "Error deleting user:",
                deleteResponse.data.executeMessage
              );
              Swal.fire("Error", "Failed to delete the product.", "error");
            }
          } catch (deleteError) {
            console.error("Error during deletion:", deleteError);
            Swal.fire("Error", "An error occurred during deletion.", "error");
          }
        } else {
          console.log("Product deletion cancelled");
        }
      } else {
        console.error("Product data not found in response");
        Swal.fire("Error", "Product not found.", "error");
      }
    } catch (error) {
      console.error("Error fetching product details:", error);
      Swal.fire(
        "Error",
        "An error occurred while fetching product details.",
        "error"
      );
    }
  };

  const fetchData = async () => {
    const token = localStorage.getItem("token")?.replace(/['"]/g, "");
    setLoading(true); // Turn on loading state before the API call
    try {
      const response = await axios.get(
        `${config.baseUrl}/Projects/projects`,

        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
          withCredentials: true,
        }
      );

      // Map API response to match DataGrid row structure
      const mappedRows = response.data.map((item, index) => ({
        id: item.id,
        //img: item.img, // Ensure your API returns `imgUrl`
        proj_name: item.proj_name,
        start_dt: item.start_dt,
        //rate: item.rate,
      }));

      setRows(mappedRows); // Update rows state with mapped data
    } catch (error) {
      console.error("Error fetching data:", error);
    } finally {
      setLoading(false); // Turn off loading state after the API call is finished
    }
  };

  const style = {
    position: "absolute",
    top: "50%",
    left: "50%",
    transform: "translate(-50%, -50%)",
    width: 400,
    bgcolor: "background.paper",
    boxShadow: 24,
    p: 4,
    borderRadius: "10px",
    height: 300,
    //overflow: "auto",
  };
  const handleProdNameChange = (e) => {
    const value = e.target.value;
    setProdName(value);
    if (value.length > 255) {
      setProdNameError("Name must not exceed 255 characters.");
    } else {
      setProdNameError("");
    }
  };

  const handleDateChange = (newValue) => {
    setSelectedDate(newValue.format("YYYY-MM-DD")); // Update the local state
    handleDateOfPurchaseChange(newValue); // Pass the newValue to the parent handler
  };

  const handleDateOfPurchaseChange = (newValue) => {
    if (newValue === null) {
      setDateOfPurchase_error("Date must not be empty.");
    } else {
      setDateOfPurchase_error(""); // Clear error if valid
    }
    setDateOfPurchase(newValue); // Set the selected date in state
    //setDateOfPurchase(newValue.format("YYYY-MM-DD"));
  };

  const handleRateChange = (e) => {
    const value = e.target.value;
    setRate(value);
    if (value == "") {
      setDateOfPurchase_error("Rate must not be empty.");
    } else {
      setDateOfPurchase_error("");
    }
  };

  useEffect(() => {
    fetchData();
    setSelectedDate(dayjs(start_dt || new Date()));
  }, [start_dt]);

  const handleSubmit = async () => {
    // Create the data object that you want to send in the API request
    const userData = {
      proj_name: proj_name,
      start_dt: start_dt,
      creator_id: localStorage.getItem("user_id"), // Assuming this is the URL of the uploaded image
    };

    try {
      // Log the data to the console for debugging
      console.log("Form Data Submitted:");
      console.log(userData);

      // Call the API with a POST request
      const response = await axios.post(
        `${config.baseUrl}/Projects/addProjects`,
        userData, // Send the data as the request body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set the content type to JSON
          },
        }
      );

      // Handle the response
      if (response.status === 200) {
        console.log("Product successfully added:");

        // Clear form fields
        setProdName("");
        setDateOfPurchase("");
        setRate("");
        setUploadedImage(null); // Clear the uploaded image URL
        setOpen(false); // Close the modal
        // Show success message using SweetAlert
        Swal.fire({
          title: "Success!",
          text: response.data.executeMessage,
          icon: "success",
          confirmButtonText: "OK",
        });

        // Optionally, call fetchData to refresh the data after adding a new user
        fetchData();
      }
    } catch (error) {
      // Handle any errors
      console.error("Error adding product:", error);
      setOpen(false);
      // Show error message using SweetAlert
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while adding the product. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  const handleUpdate = async () => {
    // Create the data object that you want to send in the API request
    const userData = {
      id: selectedUserId,
      proj_name: proj_name,
      start_dt: start_dt,
      //   rate: rate,
      //   img: uploadedImage, // Assuming this is the URL of the uploaded image
    };

    try {
      // Log the data to the console for debugging
      console.log("Form Data Submitted:");
      console.log(userData);

      // Call the API with a POST request
      const response = await axios.post(
        `${config.baseUrl}/Projects/editProjects`,
        userData, // Send the data as the request body
        {
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json", // Set the content type to JSON
          },
        }
      );

      // Handle the response
      if (response.status === 200) {
        console.log(
          "Project successfully added:",
          response.data.executeMessage
        );

        // Clear form fields
        setProdName("");
        setDateOfPurchase("");
        setRate("");
        setUploadedImage(null); // Clear the uploaded image URL
        setOpen(false); // Close the modal
        // Show success message using SweetAlert
        Swal.fire({
          title: "Success!",
          text: response.data.executeMessage,
          icon: "success",
          confirmButtonText: "OK",
        }).then((result) => {
          if (result.isConfirmed) {
            window.location.reload();
          }
        });

        // Optionally, call fetchData to refresh the data after adding a new user

        fetchData();
      }
    } catch (error) {
      // Handle any errors
      console.error("Error adding product:", error);
      setOpen(false);
      // Show error message using SweetAlert
      Swal.fire({
        title: "Error!",
        text: "Something went wrong while editing the product. Please try again.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };

  return (
    <div>
      <Box />

      <Box sx={{ display: "flex" }}>
        <Sidenav />
        <Box
          component="main"
          sx={{
            flexGrow: 1,
            p: 3,
            width: { sm: `calc(100% - ${drawerWidth}px)` },
          }}
        >
          <Toolbar />
          <Button
            variant="contained"
            onClick={handleOpen}
            startIcon={<AddCircleOutlineIcon />}
            sx={{ mb: 2 }}
          >
            Add
          </Button>
          <Modal
            open={open}
            onClose={handleClose}
            aria-labelledby="modal-modal-title"
            aria-describedby="modal-modal-description"
          >
            <Box sx={style}>
              <Typography
                id="modal-modal-title"
                variant="h6"
                component="h2"
                textAlign="center"
                fontWeight={"bold"}
              >
                {selectedUserId == null ? "Add Project" : "Edit Project"}
                <hr />
              </Typography>
              <Typography id="modal-modal-description" sx={{ mt: 2 }}>
                <TextField
                  id="standard-basic"
                  label="Project Name"
                  variant="outlined"
                  value={proj_name}
                  onChange={handleProdNameChange}
                  error={!!prod_nameError}
                  helperText={prod_nameError}
                  fullWidth
                  sx={{ mb: 2 }}
                />

                <LocalizationProvider dateAdapter={AdapterDayjs}>
                  <DatePicker
                    sx={{ width: "100%", mb: 2 }}
                    label="Start Date"
                    value={start_dt ? dayjs(start_dt, "YYYY-MM-DD") : null} // Convert string to Dayjs object
                    onChange={handleDateChange}
                    error={!!date_of_purchase_error}
                    helperText={date_of_purchase_error}
                    renderInput={(params) => (
                      <TextField {...params} variant="standard" />
                    )}
                    format="YYYY-MM-DD"
                  />
                </LocalizationProvider>

                <Stack
                  spacing={2}
                  direction="row"
                  sx={{ mt: 2 }}
                  alignItems={"center"}
                  justifyContent={"center"}
                >
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#347928" }}
                    onClick={
                      selectedUserId == null ? handleSubmit : handleUpdate
                    }
                  >
                    {selectedUserId == null ? "Submit" : "Update"}
                  </Button>
                  <Button
                    variant="contained"
                    sx={{ backgroundColor: "#D7D3BF", color: "#000" }}
                    onClick={handleClose}
                  >
                    Close
                  </Button>
                </Stack>
              </Typography>
            </Box>
          </Modal>
          <Paper sx={{ height: 400, width: "100%" }}>
            <DataGrid
              rows={rows}
              columns={columns}
              initialState={{ pagination: { paginationModel } }}
              pageSizeOptions={[5, 10]}
              sx={{ border: 0 }}
            />
          </Paper>
        </Box>
      </Box>
    </div>
  );
}
